export const filterTrandByLoad = (text, defaultG) => {
  var evaluateClass = ''
  var g = defaultG ? parseInt(defaultG) : 1
  if (text === '利多') {
    evaluateClass = 'liduo'
    if (g === 2) {
      evaluateClass = 'likong'
      text = '利空'
    }
  } else if (text === '利空') {
    evaluateClass = 'likong'
    if (g === 2) {
      evaluateClass = 'liduo'
      text = '利多'
    }
  } else if (text === '无影响') {
    text = '影响较小'
    evaluateClass = 'wuyingxiang'
  } else if (text === '利多2') {
    text = '利多'
    evaluateClass = 'liduo2'
    if (g === 2) {
      evaluateClass = 'likong2'
      text = '利空'
    }
  } else if (text === '利空2') {
    text = '利空'
    evaluateClass = 'likong2'
    if (g === 2) {
      evaluateClass = 'liduo2'
      text = '利多'
    }
  } else if (text === '无影响2') {
    text = '影响较小'
    evaluateClass = 'wuyingxiang2'
  }

  var rege = new RegExp('影响')
  if (rege.test(text)) {
    text = '影响较小'
  }
  return [evaluateClass, text]
}

export const filterTrandByChange = (text, trand) => {
  var trands = []
  if (trand === 'liduo') {
    trands.push('likong')
  } else if (trand === 'likong') {
    trands.push('liduo')
  } else if (trand === 'liduo2') {
    trands.push('likong2')
  } else if (trand === 'likong2') {
    trands.push('liduo2')
  }

  if (text === '利多') {
    trands.push('利空')
  } else if (text === '利空') {
    trands.push('利多')
  }
  return trands
}

export const genClassName = (data, stockAffect) => {
  const { actual, star, type, country, datanameId, yingxiang, indicator_id } = data
  if (actual === null || actual === '') {
    return {
      statusClass: '',
      statusName: '未公布'
    }
  }
  const previous = data.previous && parseFloat(data.previous)
  const consensus = data.consensus && parseFloat(data.consensus)
  const id = datanameId || indicator_id
  const num = consensus !== null ? consensus : previous
  const important = star > 2
  const affect = type === 0 && id ? 0 : (typeof yingxiang !== 'undefined' ? yingxiang : data.affect)
  let liduoAffect = 0
  const stockAffectLength = Object.keys(stockAffect).length
  const curStockAffect = stockAffect[country]
  let name = ''
  if (type === 0 && stockAffectLength && curStockAffect && id) {
    if ((curStockAffect.negative && curStockAffect.negative.indexOf(id) !== -1) || (curStockAffect.positive && curStockAffect.positive.indexOf(id) === -1)) {
      liduoAffect = 1
    }
  }
  if ((!num && num !== 0) || actual === num) {
    name = '无影响'
  } else {
    if (liduoAffect === affect) {
      name = actual > num ? '利多' : '利空'
    } else {
      name = actual > num ? '利空' : '利多'
    }
  }
  const evaluateArry = filterTrandByLoad(important ? name : name + '2')
  return {
    statusClass: evaluateArry[0],
    statusName: evaluateArry[1]
  }
}


// WEBPACK FOOTER //
// ./src/commons/kind.js